<template>
  <list-table
    :url="url"
    title="لیست تسویه های شناسه دار"
    :fields="fields"
    :params="params"
    :btns="btns"
    :excelroute="'excelroute'"
  ></list-table>
</template>
  <script>
/**
 * @module TableShowData
 * Custom Vue.js component to display data in a table format
 */
import TableShowData from "../../components/table";

/**
 * @module persianDate
 * Helper function to format date in persian format
 */
import persianDate from "../../helpers/persianDate";

/**
 * @module SET_BREADCRUMB
 * Action to set breadcrumb for the page
 */
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "depositList",
  data() {
    return {
      /**
       * The API endpoint for fetching the data for the table
       */
      url: "payid/list/adm",
      /**
       * An array of objects that define the columns to be displayed in the table
       * @property {string} key - the key to be used for each column
       * @property {string} label - the label to be displayed in the table header
       * @property {string} [tdClass] - the class to be applied to the data in the column
       * @property {function} [formatter] - a function to format the data in the column
       */
      fields: [
        {
          key: "payid",
          label: "شناسه واریز",
        },
        {
          key: "amount",
          label: "مبلغ (ریال)",
          tdClass: "ltr",
          /**
           * function that format the data in the column
           * @param {string} value - the value of the column
           * @param {string} key - the key of the column
           * @param {Object} item - the item of the column
           */
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "created_at",
          label: "تاریخ و ساعت",
          /**
           * function that format the data in the column
           * @param {string} value - the value of the column
           * @param {string} key - the key of the column
           * @param {Object} item - the item of the column
           */
          formatter(value, key, item) {
            return (
              persianDate.getDateByFormat(value) +
              " , " +
              persianDate.getTime(value)
            );
          },
        },
        {
          key: "status",
          label: "وضعیت",
          /**

          @param {number} value - The value of the "status" key for a given item.
          @param {string} key - The key for the current column.
          @param {object} item - The entire item object.
          @returns {string} - The formatted status string.
          Formatter function for the "status" column. It takes in the value of the "status" key for a given item,
          the key of the current column, and the entire item object. It returns a formatted string based on the value.
          If the value is 0, it returns "در دست بررسی". If the value is 1, it returns "واریز شده". Otherwise, it returns "ریفاند شده".
          */

          formatter(value, key, item) {
            switch (value) {
              case 0:
                return "در دست بررسی";
              case 1:
                return "واریز شده";
              case 2:
                return "ریفاند شده";
              case 4:
                return "مبلغ واریزی یکسان نیست";

              default:
                return "ناشناخته";
            }
          },
          /**

          @param {number} value - The value of the "status" key for a given item.
          @param {string} key - The key for the current column.
          @param {object} item - The entire item object.
          @returns {string} - The CSS class to be applied to the table cell.
          tdClass function for the "status" column. It takes in the value of the "status" key for a given item,
          the key of the current column, and the entire item object. It returns a CSS class based on the value.
          If the value is 0, it returns "text-primary". If the value is 1, it returns "text-success".
          Otherwise, it returns "text-danger".
          */
          tdClass(value, key, item) {
            return value == 0
              ? "text-primary"
              : value == 1
              ? "text-success"
              : "text-danger";
          },
        },
        {
          key: "btns",
          label: "جزییات",
        },
      ],
      btns: [
        {
          title: "جزییات",
          icon: "eye",
          handler: (t) => {
            this.$router.push(`deposit-details/${t.id}`);
          },
        },
      ],
      params: [
        {
          label: "از تاریخ:",
          field: "dateFrom",
          type: "date-picker",
        },
        {
          label: "تا تاریخ:",
          field: "dateTo",
          type: "date-picker",
        },
        {
          label: "وضعیت:",
          field: "status",
          type: "select",
          options: [
            { value: null, text: "همه ی موارد" },
            { value: "1", text: "تایید شده" },
            { value: "2", text: "برگشت شده" },
            { value: "4", text: "مبلغ واریزی اشتباه" },
          ],
        },
        {
          label: "تاریخ تایید از:",
          field: "c_dateFrom",
          type: "date-picker",
        },
        {
          label: "تاریخ تایید تا:",
          field: "c_dateTo",
          type: "date-picker",
        },
        {
          label: "شناسه واریز:",
          field: "payid",
          type: "text",
        },
        {
          label: "مبلغ واریزی:",
          field: "amount",
          type: "number",
        },
      ],
    };
  },
  components: {
    /**
     * @type {TableShowData}
     */
    "list-table": TableShowData,
  },
  /**
   * Vue.js lifecycle hook, it will be called when the component is mounted
   * @function
   */
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "لیست تسویه های شناسه دار" },
    ]);
  },
};
</script>
  <style>
.ltr {
  direction: ltr;
}
</style>